import { ApiError } from "../api/client";

export function isUnauthenticatedApiError(error: unknown): boolean {
  return error instanceof ApiError && error.status === 401;
}

export function getProtectedApiErrorMessage(
  error: unknown,
  fallbackMessage: string
): string {
  if (isUnauthenticatedApiError(error)) {
    return "セッションの確認に失敗しました。/entry から再度ログインしてください。";
  }

  return error instanceof Error ? error.message : fallbackMessage;
}
